var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$tc("report.fls34.tab_6")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }